<template>
  <el-dialog
    title="修改发票信息"
    :visible.sync="dialogVisible"
    class="form-loading"
    :modal-append-to-body="false"
  >
    <el-form
      :model="form"
      ref="form"
      :rules="rules"
      label-width="120px"
      @open="close"
      label-position="left"
    >
      <el-form-item label="公司名称：" prop="invoiceTitle">
        <el-input
          placeholder="请输入公司名称"
          v-model="form.invoiceTitle"
        ></el-input>
      </el-form-item>

      <el-form-item label="纳税人识别号：" prop="taxNumber">
        <el-input
          placeholder="请输入纳税人识别号"
          v-model="form.taxNumber"
        ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>

      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { ObjectAssignSingle } from '@/utils'
import { modifyFirstInfo } from '@/api/distributor-api'
import { EDIT_INVOICE_INFORMATION_RULE } from '@/views/service/rules'
export default {
  name: 'EditInvoiceInformation',
  props: {
    infoData: {
      require: true,
    },
  },
  data() {
    return {
      dialogVisible: false,
      rules: EDIT_INVOICE_INFORMATION_RULE(),
      form: {
        invoiceTitle: '',
        taxNumber: '',
      },
    }
  },
  methods: {
    showDialog() {
      this.dialogVisible = true
      ObjectAssignSingle(this.form, this.infoData)
      this.handParams()
    },
    // 关闭清空表单信息
    close() {
      this.$refs.form.resetFields()
    },
    submit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let params = this.handParams()
          if (!params) {
            this.dialogVisible = false
            return false
          }
          let { distributorId, contractSubject } = this.infoData
          // 后端说这几个参数必传
          params.distributorId = distributorId
          params.contractSubject = contractSubject
          await modifyFirstInfo(params)
          this.outMsg('success', '提交成功')
          this.dialogVisible = false
          this.$emit('success')
        } else {
          return false
        }
      })
    },
    handParams() {
      let { invoiceTitle, taxNumber } = this.form
      let params = {}
      if (invoiceTitle !== this.infoData.invoiceTitle) {
        params.invoiceTitle = invoiceTitle
      }
      if (taxNumber !== this.infoData.taxNumber) {
        params.taxNumber = taxNumber
      }
      let keys = Object.keys(params)
      if (keys.length > 0) {
        return params
      } else {
        return false
      }
    },
  },
}
</script>
